import { render, staticRenderFns } from "./ContactosPantalla.vue?vue&type=template&id=61ac13d4&"
import script from "./ContactosPantalla.vue?vue&type=script&lang=ts&"
export * from "./ContactosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61ac13d4', component.options)
    } else {
      api.reload('61ac13d4', component.options)
    }
    module.hot.accept("./ContactosPantalla.vue?vue&type=template&id=61ac13d4&", function () {
      api.rerender('61ac13d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Contactos/ContactosPantalla.vue"
export default component.exports